module.exports = "/images/london-7.jpg";